let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bCy5U")).then(() => parcelRequire('7b8i9'));